import styled from 'styled-components/macro';
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack
} from "@chakra-ui/react";
import {useState} from "react";
import {useReset} from "../../api/reset";
import {useFeedback} from "../../store/feedback";
import {useHistory} from "react-router-dom";

const titles = ['Next', 'Reset', 'Done'];

const ResetPassword = styled(({onClose}) => {

    const [username, setUsername] = useState();
    const [email, setEmail] = useState();

    const {error, feedbackCh} = useFeedback();
    const reset = useReset(feedbackCh);

    const history = useHistory();
    const [page, setPage] = useState(1);
    const handleNext = async () => {
        if (page === 2) {
            // send password request
            if (!email || !username) return;
            await reset(username, email);
        }
        if (page === 3) {
            onClose();
            history.push('/');
        }
        setPage(page + 1);
    };

    return (
        <>
            <Modal
                isOpen
                onClose={onClose}
                size={'xl'}
                closeOnOverlayClick={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Reset Password</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>

                            <Stack spacing={'5'}>

                                {page === 1 &&
                                    <>
                                        <p>In order to reset your password, you must have an email address associated with your
                                            account.</p>

                                        <p>You must also know that email address, as we have no way to recover it.</p>
                                    </>
                                }

                                {page === 2 &&
                                    <>
                                        <FormControl>
                                            <FormLabel>Username</FormLabel>
                                            <Input value={username} onChange={(e) => setUsername(e.currentTarget.value)}/>
                                        </FormControl>
                                        <FormControl>
                                            <FormLabel>Email Address</FormLabel>
                                            <Input value={email} onChange={(e) => setEmail(e.currentTarget.value)}/>
                                        </FormControl>

                                    </>
                                }

                                {page === 3 &&
                                <>
                                    <p>
                                        If the username and email address exist, we will send a reset link now.
                                    </p>
                                    <p>
                                        Check your spam folder.
                                    </p>
                                </>}

                            </Stack>

                    </ModalBody>

                    <ModalFooter>
                        {page !== 3 && <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>}
                        <Button variant="blue" onClick={handleNext}>
                            {titles[page-1]}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
})``;

export default ResetPassword;
